const servicesObject = {
    configName: 'services',
    container: null,
    elements: [],
    speed: .008,
    status: -1,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;
        this.container = document.querySelector('.services__container');

        const elements = this.container.getElementsByClassName('services');

        for (let i = 1, size = elements.length; i < size; i++) {
            this.elements.push({
                'elm': elements[i],
                'offset': 0
            });
        }
    },
    reactToScroll: function (data) {
        if (!data.isVisible) return;

        for (const target of this.elements) {
            const elementRect = target.elm.getBoundingClientRect();
            const offsetCenter = -(window.innerHeight / 2 - (elementRect.top + elementRect.height) + target.offset);

            target.offset = offsetCenter > 0 ? Math.pow((offsetCenter * this.speed - 1), 3) + 1 : 0;
            target.elm.style.transform = 'translate3d(0,' + target.offset + 'px , 0)';
        }

        this.container.style.transform = 'translate3d(0,' + Math.round(-data.localOffset * 100) / 100 + 'px , 0)';
    },
    reactToResize: function () {
        for (const target of this.elements) {
            target.elm.style.transform = '';
        }
        this.container.style.transform = '';
    }
};
